import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { AxiosError } from "axios";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";

export class AvailabilitiesValues extends ListOfPropertiesValues {
  availabilityTemplate = this.getAvailabilityTemplates;
  serviceTemplate = this.getServiceTemplates;
  campus = this.getCampus;
  space = this.getSpaces;
  dependency = this.getDependenciesList;
  responsable = this.getUsers;
  createdBy = this.getUsers;
  changedBy = this.getUsers;

  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof AvailabilitiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof AvailabilitiesValues]();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getServiceTemplates() {
    return await this.getServiceTemplatesCommonFunction();
  }

  async getAvailabilityTemplates(name: string) {
    return await this.getAvailabilityTemplatesCommonFunction(
      this.lastDocId,
      name
    );
  }

  async getCampus() {
    return await this.getCampusCommonFunction();
  }

  async getSpaces() {
    return await this.getSpacesCommonFunction();
  }

  async getDependenciesList() {
    try {
      return await this.getDependenciesListCommonFunction(this.lastDocId);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUsers(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }
  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }
}
